import React from 'react'
import Footer from '../Footer'
import RogerThree from '../RogerThree'

function Roger3() {
    window.scrollTo(0,0);
    return (
        <div>
            <RogerThree/>
            <Footer/>
        </div>
    )
}

export default Roger3
